import { getShiftDate, getFormattedTimeStamp } from "../dateTimeFormatter";

var FlexSearch = require("flexsearch");

var index;

export function initializeSearchIndex(bids) {
  index = new FlexSearch({
    doc: {
      id: "pk",
      profile: "speed",
      field: {
        createdAt: {},
        bidType: {},
        workgroup: {},
        bidName: {},
        schedEndDate: {},
        schedStartDate: {},
        windowEndDate: {},
        windowStartDate: {},
        status: {},
        station: {},
        scheduledStatus: {},
      },
    },
  });

  index.add(bids);
}

export function searchBids(searchString, applySearchCallback) {
  if (index) {
    let result = index.where(
      function (item) {
        const lastUpdated = getFormattedTimeStamp(item.createdAt);
        if (lastUpdated.includes(searchString)) {
          return true;
        }

        if (item.station.toLowerCase().includes(searchString.toLowerCase())) {
          return true;
        }

        if (item.bidType.toLowerCase().includes(searchString.toLowerCase())) {
          return true;
        }

        if (item.workgroup.toLowerCase().includes(searchString.toLowerCase())) {
          return true;
        }

        if (item.bidName && item.bidName.toLowerCase().includes(searchString.toLowerCase())) {
          return true;
        }

        if (item.schedStartDate && item.schedEndDate) {
          const bidEffectiveDate = getShiftDate(item.schedStartDate) + " - " + getShiftDate(item.schedEndDate);
          if (bidEffectiveDate.includes(searchString)) {
            return true;
          }
        }

        if (item.windowEndDate && item.windowStartDate) {
          const bidWindow =
            getShiftDate(item.windowStartDate) + " - " + item.windowEndDate.toFormat("LL/dd/yyyy',' T ZZZZ");
          if (bidWindow.toLowerCase().includes(searchString.toLowerCase())) {
            return true;
          }
        }

        if (item.status.toLowerCase().includes(searchString.toLowerCase())) {
          return true;
        }

        if (item.scheduledStatus && item.scheduledStatus.toLowerCase().includes(searchString.toLowerCase())) {
          return true;
        }

        return false;
      },
      (result) => {
        applySearchCallback(searchString, result);
      }
    );
    applySearchCallback(searchString, result);
  }
}
